import { IconUsersGroup, IconX } from '@tabler/icons-react';
import dayjs from 'dayjs';

import { MostRecentCampaign } from 'pages/Campaign/PerformanceResults/api/usePerformanceResultsNotification/usePerformanceResultsNotification';
import Button from '@lotlinx-aws/sparky-component-library/Sparky/Button';
import Card from '@lotlinx-aws/sparky-component-library/Sparky/Card';
import Flex from '@lotlinx-aws/sparky-component-library/Sparky/Flex';
import IconButton from '@lotlinx-aws/sparky-component-library/Sparky/IconButton';
import Modal from '@lotlinx-aws/sparky-component-library/Sparky/Modal';
import Text from '@lotlinx-aws/sparky-component-library/Sparky/Text';
import { formatNumber } from 'util/formatters';

import styles from './PerformanceResultsPopup.module.scss';

export interface PerformanceResultsPopupProps {
  isInitialLoginPerformanceResults: boolean;

  handleDismiss(): void;

  mostRecentCampaign: MostRecentCampaign;
}

/**
 * PerformanceResultsPopup
 */
export default function PerformanceResultsPopup({
  isInitialLoginPerformanceResults,
  handleDismiss,
  mostRecentCampaign,
}: PerformanceResultsPopupProps) {
  const elapsedDays = dayjs().diff(dayjs(mostRecentCampaign?.startDate), 'days');

  // HIDE COMPONENT ON MOCK SERVER
  if (import.meta.env.VITE_APP_USE_MOCK) {
    return <></>;
  }

  return (
    <Modal
      aria-label='Performance results popup'
      isOpen={isInitialLoginPerformanceResults}
      onDismiss={handleDismiss}
      contentClassName={styles.performanceResultsPopup}
    >
      <Text type='label-emphasized-01' alignment='center'>
        Welcome to VIN Manager!
      </Text>
      <Flex column alignItems='center' rowGap='16px'>
        <Text type='body-01' color='secondary' alignment='center'>
          Your Performance Manager has already started a new campaign for you with{' '}
          {formatNumber(mostRecentCampaign?.targetedVins)} VINs chosen by our state of the art AI!
        </Text>
        {!mostRecentCampaign?.targetedVins ? (
          <Text type='body-01' fontWeight={7} alignment='center'>
            The machine has started to go to work and on day 5 we’ll review your shopper delivery
            with you!
          </Text>
        ) : (
          <Card
            type='embedded'
            heading={`Since your campaign started ${
              elapsedDays === 0
                ? 'earlier today'
                : `${elapsedDays} day${elapsedDays === 1 ? '' : 's'} ago`
            } it has`}
          >
            <Flex alignItems='center' columnGap='10px'>
              <div className={styles.icon}>
                <IconUsersGroup />
              </div>
              <Text type='data-callout'>
                {formatNumber(mostRecentCampaign.totalShoppersDelivered)} shopper
                {mostRecentCampaign.totalShoppersDelivered === 1 ? '' : 's'} delivered
              </Text>
            </Flex>
          </Card>
        )}
      </Flex>

      <Button variant='outline' onClick={handleDismiss} className={styles.dismissBtn}>
        Dismiss
      </Button>

      <IconButton
        aria-label='close welcome modal'
        onClick={handleDismiss}
        className={styles.closeBtn}
      >
        <IconX />
      </IconButton>
    </Modal>
  );
}
